import React, { Component } from 'react';

import {
  fetchSprintCurrentCycle,
  fetchAttCurrentCycle,
  fetchSimoCurrentCycle,
  fetchQuickCurrentCycle,
} from 'api';

const withCurrentCycle = (DecoratedComponent, fetchCurrentCycle) => {
  class WithCurrentCycle extends Component {
    constructor(props) {
      super(props);

      this.state = {
        currentCycle: undefined,
      };
    }

    componentDidMount() {
      const { subId } = this.props;
      if (subId) {
        this.fetchCycle(subId);
      }
    }

    componentDidUpdate(oldProps) {
      const { subId } = this.props;
      if (oldProps.subId !== subId) {
        this.fetchCycle(subId);
      }
    }

    fetchCycle = async (subId) => {
      let results;
      try {
        const { data } = await fetchCurrentCycle(subId);
        results = data.results;
      } catch (error) {
        results = [];
      } finally {
        this.setState({
          currentCycle: results,
        });
      }
    };

    render() {
      const { children, ...props } = this.props;
      const { currentCycle } = this.state;

      return React.createElement(
        DecoratedComponent,
        { ...props, currentCycle, fetchCycle: this.fetchCycle },
        children,
      );
    }
  }

  return WithCurrentCycle;
};

export const withSprintCurrentCycle = (DecoratedComponent) =>
  withCurrentCycle(DecoratedComponent, fetchSprintCurrentCycle);
export const withAttCurrentCycle = (DecoratedComponent) =>
  withCurrentCycle(DecoratedComponent, fetchAttCurrentCycle);
// Cycle API is unavailable for TracFone
export const withTracfoneCurrentCycle = (DecoratedComponent) =>
  withCurrentCycle(DecoratedComponent, () => {});
export const withSimoCurrentCycle = (DecoratedComponent) =>
  withCurrentCycle(DecoratedComponent, fetchSimoCurrentCycle);
export const withQuickCurrentCycle = (DecoratedComponent) =>
  withCurrentCycle(DecoratedComponent, fetchQuickCurrentCycle);

export default withSprintCurrentCycle;
